// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel {
    'rxNumber'?: number;
    'dobMmDdYyyy'?: string | null;
    'phoneNumber'?: string | null;
    'ivrReference'?: string | null;
    'tfnDid'?: string | null;
    'dobMmDdYyyyIsValid'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel>> = [
        {
            "name":     "rxNumber",
            "baseName": "rxNumber",
            "type":     "number"
        },
        {
            "name":     "dobMmDdYyyy",
            "baseName": "dobMmDdYyyy",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "ivrReference",
            "baseName": "ivrReference",
            "type":     "string"
        },
        {
            "name":     "tfnDid",
            "baseName": "tfnDid",
            "type":     "string"
        },
        {
            "name":     "dobMmDdYyyyIsValid",
            "baseName": "dobMmDdYyyyIsValid",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return TcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel.attributeTypeMap;
    }
}
